import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { clone as r } from "./lang.js";

function n(r, n) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  return e(r, n, t);
}

function t(r, n) {
  if (null != n) return n[r] || i(r.split("."), !1, n);
}

function o(r, n, t) {
  var o = r.split("."),
      e = o.pop(),
      u = i(o, !0, t);
  u && e && (u[e] = n);
}

function i(r, n, t) {
  var o = t;

  var _iterator = _createForOfIteratorHelper(r),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _i = _step.value;
      if (null == o) return;

      if (!(_i in o)) {
        if (!n) return;
        o[_i] = {};
      }

      o = o[_i];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return o;
}

function e(n, t, o) {
  return t ? Object.keys(t).reduce(function (n, i) {
    var u = n[i],
        c = t[i];
    return u === c ? n : void 0 === u ? (n[i] = r(c), n) : (Array.isArray(c) || Array.isArray(n) ? (u = u ? Array.isArray(u) ? n[i] = u.concat() : n[i] = [u] : n[i] = [], c && (Array.isArray(c) || (c = [c]), o ? c.forEach(function (r) {
      -1 === u.indexOf(r) && u.push(r);
    }) : n[i] = c.concat())) : c && "object" == typeof c ? n[i] = e(u, c, o) : n.hasOwnProperty(i) && !t.hasOwnProperty(i) || (n[i] = c), n);
  }, n || {}) : n;
}

export { n as deepMerge, t as getDeepValue, o as setDeepValue };